<script setup>
import { computed } from 'vue'

import { extraFieldTypeEnum } from '@/stores/portal.store'

const props = defineProps({
  fields: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: Object,
    default: () => ({}),
  },
  compact: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const inputFields = computed(() => props.fields.filter(field => field.field_type !== extraFieldTypeEnum.BOOLEAN))
const toggleFields = computed(() => props.fields.filter(field => field.field_type === extraFieldTypeEnum.BOOLEAN))

const valueOf = (field) => props.modelValue?.[String(field.id)] ?? null
const update = (field, value) => emit('update:modelValue', { ...props.modelValue, [String(field.id)]: value === '' ? null : value })
const colClass = (index) => (props.compact || (index === inputFields.value.length - 1 && index % 2 === 0) ? 'col-12' : 'col-6')
</script>

<template>
  <template v-for="(field, index) in inputFields" :key="field.id">
    <q-select
      v-if="field.field_type === extraFieldTypeEnum.SELECT"
      :model-value="valueOf(field)"
      :class="colClass(index)"
      :label="field.name"
      :options="field.options"
      clearable
      :readonly="readonly"
      @update:model-value="update(field, $event)"
    />
    <q-input
      v-else-if="field.field_type === extraFieldTypeEnum.NUMBER"
      :model-value="valueOf(field)"
      :class="colClass(index)"
      :label="field.name"
      type="number"
      :readonly="readonly"
      @update:model-value="update(field, $event === '' ? null : Number($event))"
    />
    <q-input
      v-else-if="field.field_type === extraFieldTypeEnum.DATE"
      :model-value="valueOf(field)"
      :class="colClass(index)"
      :label="field.name"
      type="date"
      stack-label
      :readonly="readonly"
      @update:model-value="update(field, $event)"
    />
    <q-input
      v-else
      :model-value="valueOf(field)"
      :class="colClass(index)"
      :label="field.name"
      autogrow
      :readonly="readonly"
      @update:model-value="update(field, $event)"
    />
  </template>
  <div v-if="toggleFields.length" class="col-12 row q-gutter-md">
    <q-toggle
      v-for="field in toggleFields"
      :key="field.id"
      :model-value="valueOf(field) ?? false"
      :label="field.name"
      :disable="readonly"
      @update:model-value="update(field, $event)"
    />
  </div>
</template>
